import { ParcelContractDetailCmp } from '@/components/features/parcels/listing/ParcelContractDetailCmp'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useParcelContractDetail } from '@/hooks/api/useParcels'
import { useParams } from '@tanstack/react-router'
import { PageContainer } from '@/components/features/shared/PageContainer'

export const ParcelContractPage = () => {
  const { contractId, parcelId } = useParams({ strict: false }) as { contractId: string, parcelId: string }
  const { data: detail, isLoading } = useParcelContractDetail({ contractId, parcelId })

  if (isLoading) {
    return (
      <div className="container mx-auto py-8 space-y-4">
        <Skeleton className="h-8 w-48 mb-6" />
        <div className="grid gap-4 md:grid-cols-3">
          <Card className="md:col-span-2">
            <CardHeader><Skeleton className="h-6 w-3/4" /></CardHeader>
            <CardContent><Skeleton className="h-40 w-full" /></CardContent>
          </Card>
          <Card>
            <CardHeader><Skeleton className="h-6 w-3/4" /></CardHeader>
            <CardContent><Skeleton className="h-40 w-full" /></CardContent>
          </Card>
        </div>
      </div>
    )
  }

  if (!detail) {
    return (
      <div className="container mx-auto py-8 text-center">
        <p>No se encontró la información de la parcela</p>
        <Button variant="outline" className="mt-4" onClick={() => window.history.back()}>
          Volver
        </Button>
      </div>
    )
  }

  return (
    <PageContainer>
      <ParcelContractDetailCmp detail={detail} />
    </PageContainer>
  )
}
